const assets = {
  images: {
    signinBg: new URL(
      '/images/signinSignupBg/sexagogo-bg-login.jpg',
      import.meta.url,
    ).href,
    signupBg: new URL(
      '/images/signinSignupBg/sexagogo-bg-register.jpg',
      import.meta.url,
    ).href,
  },
}

export default assets
